<template>
  <section>
    <b-field label="Site Adı" horizontal>
      <b-input
        v-model="general.siteName"
        type="text"
        placeholder="Site Adı"
        validation-message="Site Adı zorunlu."
        required
      />
    </b-field>
    
    <b-field horizontal>
      <b-checkbox v-model="general.driverCarAndVehicleSelectableWithDriverRole" :value="false">
        Sürücü ve Araç Bilgilerinin Sürücü Rolünde Seçilebilmesi
      </b-checkbox>
    </b-field>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      general: {
        siteName: '',
        driverCarAndVehicleSelectableWithDriverRole: false
      },
    }
  },
  computed: {
    ...mapGetters({
      settings: 'settings/settings',
    }),
  },
  async created () {
    if (this.settings('general').length === 0) {
      this.$emit('loading', true)

      await this.fetch()

      this.$emit('loading', false)
    }

    this.settings('general').forEach(({ name, payload }) => {
      this.general[name] = payload
    })
  },
  methods: {
    ...mapActions({
      fetch: 'settings/index',
      update: 'settings/update',
    }),
    save () {
      return this.update({ general: this.general })
    },
  },
}
</script>
